import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ChannelRail from './components/ChannelRail';
import HotTopList from './components/HotTopList';
import LiveTimeline from './components/LiveTimeline';
import Spotlight from './components/Spotlight';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ChannelRail />
        <HotTopList />
        <LiveTimeline />
        <Spotlight />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}